
let language = {
    PAYMENT_COMPLETE_PAY_SUCCEED_TITLE: "支付成功",
    PAYMENT_COMPLETE_PAY_TIME_TIP1: "此页面将在内自动跳转到\"我的订单\" ",
    PAYMENT_COMPLETE_PAY_TIME_TIP2: "秒",
    
    PAYMENT_COMPLETE_BACK_ORDER_BTN: "回到我的订单",
    PAYMENT_COMPLETE_CONTINUE_SHOPPING_BTN: "继续购物",
    
    PAYMENT_COMPLETE_URL_PARAM_CHECK_ALERT_TITLE: "警告",
    PAYMENT_COMPLETE_URL_PARAM_CHECK_ALERT_CONTENT: "缺少订单Id",
};

export { language }